import React, { useContext } from 'react';
import {
  BookingDto,
  GetPostAppointmentStateUrlDto,
  getPostAppointmentStateUrl,
  useAuth,
  useRequest,
} from '@monument/core';
import { usePostAppointmentClinicianRating } from './usePostAppointmentClinicianRating';
import { usePostAppointmentPayment } from './usePostAppointmentPayment';

export interface PostAppointmentModalState {
  modal: {
    visible: boolean;
    hide: () => void;
  };
  booking?: BookingDto;
}

interface Value {
  setCurrentAppointmentBookingId: (bookingId: string) => void;
  clinicianRatingModalState?: PostAppointmentModalState;
  upcomingAppointmentPaymentModalState?: PostAppointmentModalState;
  loading?: boolean;
  refresh: () => Promise<GetPostAppointmentStateUrlDto>;
}

const PostAppointmentStateContext = React.createContext<Value>({} as Value);
export const usePostAppointmentState = () => useContext(PostAppointmentStateContext);

export const PostAppointmentStateProvider = ({ children }) => {
  const [currentAppointmentBookingId, setCurrentAppointmentBookingId] = React.useState<string>();
  const { isAuthenticated } = useAuth();
  const {
    data: postAppointmentState,
    loading,
    refreshAsync: refresh,
  } = useRequest<GetPostAppointmentStateUrlDto>(
    getPostAppointmentStateUrl(currentAppointmentBookingId),
    {
      ready: isAuthenticated,
    },
  );

  const clinicianRatingModalState = usePostAppointmentClinicianRating(postAppointmentState);
  const upcomingAppointmentPaymentModalState = usePostAppointmentPayment(
    postAppointmentState,
    clinicianRatingModalState.modal.visible,
  );

  return (
    <PostAppointmentStateContext.Provider
      value={{
        setCurrentAppointmentBookingId,
        clinicianRatingModalState,
        upcomingAppointmentPaymentModalState,
        loading,
        refresh,
      }}
    >
      {children}
    </PostAppointmentStateContext.Provider>
  );
};
